module.exports = __webpack_public_path__ + "static/media/card-icon-01.84257158.svg";